<template slot="empty">
  <div class="sss">
    <i class="el-icon-receiving ICONnO"></i>
    <div class="noCart">暂无数据</div>
  </div>
</template>
<script>
export default {
  name: 'noCart',

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push({ path: '/shop' });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.ICONnO {
  font-size: 40px;
  margin-top: 40px;
}
.noCart {
  font-size: 15px;
  line-height: 20px;
}
.sss{
  width: 100%;
}
</style>
